/**
 * Plan 2026-09-28-008 U4 (R20/F9g) — the ONE fallback a rep sees when a
 * locked Gong flow's name can't be resolved from the browse-catalog cache
 * (a deleted/renamed flow, or the catalog hasn't loaded yet).
 *
 * `SequenceMappingDrawer.tsx`'s `resolvedFlowName` and `SequencesStep.tsx`'s
 * `lockedFlowName` both used to fall back to the RAW Gong flow id
 * (`lockedFlowName ?? lockedFlowId`) in a toast/dialog sentence and the
 * read-only "Gong flow: …" badge — exactly the kind of id R20 forbids a rep
 * from seeing. A flow id carries no meaning to a rep (it is not a Salesforce
 * id they'd recognize from another surface), so unlike the allowed
 * `campaignSfdcId` sentences, there is no case for keeping it.
 *
 * A dependency-free leaf (no React, no `_shared/hooks`) so both components
 * can import it and its own test needs no rendering harness.
 */
export function gongFlowDisplayName(name: string | null | undefined): string {
  return name ?? 'the chosen Gong flow';
}
